export const TRANSLATED_BE_REGIONS = {
  BE_BRU: {
    fr: 'Bruxelles',
    nl: 'Brussel',
  },
  BE_VAN: {
    fr: 'Anvers',
    nl: 'Antwerpen',
  },
  BE_VBR: {
    fr: 'Brabant Flamand',
    nl: 'Vlaams-Brabant',
  },
  BE_VLI: {
    fr: 'Limbourg',
    nl: 'Limburg',
  },
  BE_VOV: {
    fr: 'Flandre-Orientale',
    nl: 'Oost-Vlaanderen',
  },
  BE_VWV: {
    fr: 'Flandre-Occidentale',
    nl: 'West-Vlaanderen',
  },
  BE_WAL: {
    fr: 'Brabant Wallon',
    nl: 'Waals-Brabant',
  },
  BE_WHT: {
    fr: 'Hainaut',
    nl: 'Henegouwen',
  },
  BE_WLG: {
    fr: 'Liège',
    nl: 'Provincie Luik',
  },
  BE_WLX: {
    fr: 'Luxembourg',
    nl: 'Luxemburg',
  },
  BE_WNA: {
    fr: 'Namur',
    nl: 'Namen',
  },
};
